



























import {Component, Vue, Prop} from 'vue-property-decorator'
import {Divider} from '@@/node_modules/element-ui'

@Component({
  components: {[Divider.name]: Divider},
})
export default class CompanyItem extends Vue {
  @Prop({default: '', type: String}) name: string
  @Prop({default: '', type: String}) ownerName: string
  @Prop({default: '', type: String}) bizRegistrationNumber: string
  @Prop({default: '', type: String}) addressJibun: string
  @Prop({default: '', type: String}) addressRoad: string
  @Prop({default: '', type: String}) searchValue: string
  @Prop({default: true, type: Boolean}) external: boolean
  @Prop({default: '', type: String}) fullAddress: string

  get address() {
    if(this.external) {
      return this.addressJibun || this.addressRoad
    }
    return this.fullAddress  
  }
  
  replaceHighlightedText(text) {
    if(!text) {
      return text
    }
    return text.replace(
      this.searchValue,
      `<span class="k-text-color-blue01">${this.searchValue}</span>`,
    )
  }
}
